module.exports = {
	"supported": [
		"af",
		"ar",
		"bg",
		"ca",
		"cs",
		"da",
		"de",
		"en",
		"en-GB",
		"es",
		"es-419",
		"et",
		"fi",
		"fr",
		"gl",
		"he",
		"hr",
		"hu",
		"id",
		"it",
		"ja",
		"ko",
		"lv",
		"lt",
		"ms",
		"nl",
		"no",
		"pl",
		"pt-BR",
		"pt-PT",
		"ro",
		"ru",
		"sk",
		"sl",
		"sr",
		"sv",
		"tr",
		"uk",
		"zh",
		"zh-TW"
	],
	"editor_locales": [
		"af",
		"ar",
		"bg",
		"ca",
		"cs",
		"da",
		"de",
		"en",
		"en-GB",
		"es",
		"es-419",
		"et",
		"fi",
		"fr",
		"gl",
		"he",
		"hr",
		"hu",
		"it",
		"ja",
		"ko",
		"lt",
		"lv",
		"ms",
		"nl",
		"no",
		"pl",
		"pt-BR",
		"pt-PT",
		"ro",
		"ru",
		"sk",
		"sr",
		"sv",
		"tr",
		"uk",
		"zh",
		"zh-TW"
	],
	"event_locales": [
		"af",
		"ar",
		"bg",
		"ca",
		"cs",
		"da",
		"de",
		"en",
		"en-GB",
		"es",
		"es-419",
		"et",
		"fi",
		"fr",
		"gl",
		"he",
		"hr",
		"hu",
		"id",
		"it",
		"ja",
		"ko",
		"lv",
		"ms",
		"nl",
		"no",
		"pl",
		"pt-BR",
		"pt-PT",
		"ro",
		"ru",
		"sk",
		"sl",
		"sr",
		"sv",
		"tr",
		"uk",
		"zh",
		"zh-TW"
	],
	"client_to_iso": {
		"arabic": "ar",
		"bulgarian": "bg",
		"catalan": "ca",
		"chinese": "zh",
		"croatian": "hr",
		"czech": "cs",
		"danish": "da",
		"deutsch": "de",
		"dutch": "nl",
		"eng": "en",
		"eng_heb": "en",
		"eng_uk": "en-GB",
		"espanol": "es",
		"espanol_chile": "es-CL",
		"espanol_espana": "es-ES",
		"espanol_heb": "es",
		"espanol_venezuela": "es-VE",
		"espanol_latam": "es-419",
		"estonian": "et",
		"francais": "fr",
		"heb": "he",
		"hindi": "hi-IN",
		"hungarian": "hu",
		"italiano": "it",
		"latvian": "lv",
		"lithuanian": "lt",
		"norwegian": "no",
		"polski": "pl",
		"portuguese_br": "pt-BR",
		"portuguese_pt": "pt",
		"russian": "ru",
		"russian_heb": "ru",
		"slovak": "sk",
		"slovenian": "sl",
		"swedish": "sv",
		"japanese": "ja",
		"afrikaans": "af",
		"basque": "eu",
		"galician": "gl",
		"malay": "ms",
		"romanian": "ro",
		"serbian(latin)": "sr",
		"finnish": "fi",
		"turkish": "tr",
		"korean": "ko",
		"indonesian": "id",
		"ukrainian": "uk"
	},
	"api_to_iso": {
		"iw": "he",
		"in": "id",
		"pt-BT": "pt-BR",
		"pt_BT": "pt-BR",
		"pt_BR": "pt-BR",
		"pt_PT": "pt-PT",
		"es_419": "es-419",
		"en_GB": "en-GB",
		"zh_TW": "zh-TW"
	},
	"carpool_app_locales": [
		"en",
		"es",
		"es-419",
		"pt-BR",
		"he"
	]
};